module.exports = __webpack_public_path__ + "img/lr-cb66-010.04912f26.gif";